<script lang="ts" setup>
withDefaults(
  defineProps<{
    isHead?: boolean
    value: string
  }>(),
  { isHead: false }
)
</script>

<template>
  <td
    class="bg-main-very-light-gray p-8 text-center text-sm leading-[1.43] text-main-dark"
    :class="{'!bg-white !text-left font-medium': isHead}"
  >
    {{ value }}
  </td>
</template>
